import { Component, OnInit, Input } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Gtag } from 'angular-gtag';
import { Notification, Patient, PharmAddress, PharmItem } from 'src/app/core/models';
import { PatientState } from '../core/store/patient/patient.state';
import { OrdersState } from '../core/store/order/orders.state';
import { Order } from '../core/models';
import { ApiStoreData, CcsSentryError } from '../core/store/utils';
import { EnvService } from '../core/services';
import { NotificationsState } from '../core/store/notifications/notifications.state';
import { PharmOrdersState } from '../core/store/pharm-order/pharm-orders.state';
import { PharmOrder } from '../core/models';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PharmAddressState } from '../core/store/pharm-address/pharm-address.state';
import { FetchPharmAddress } from '../core/store/pharm-address/pharm-address.action';
import { PharmWizardSubmissionState } from '../core/store/pharm-wizard-submission/pharm-wizard-submission.state';
import { SubmitPharmReorder } from '../core/store/pharm-wizard-submission/pharm-wizard-submission.actions';
import { omit } from 'lodash-es';
import { FetchPharmOrders, SetSelectedEnterpriseOrderId } from '../core/store/pharm-order/pharm-orders.action';
import { MessageService } from 'primeng/api';
import { Observable, withLatestFrom } from 'rxjs';
@Component({
  selector: 'app-pharm-authorization',
  templateUrl: './pharm-authorization.component.html',
  styleUrls: ['./pharm-authorization.component.scss'],
})
export class PharmAuthorizationComponent implements OnInit {
  @Select(OrdersState.isLoading) isLoading$!: Observable<boolean>;
  @Select(OrdersState.error) error$!: Observable<CcsSentryError | null>;
  @Select(OrdersState.activeOrders) activeOrders$!: Observable<Order[]>;

  @Select(PharmOrdersState.selectedEnterpriseOrderId) selectedEnterpriseOrderId$!: string;
  @Select(PharmOrdersState.isLoading) isLoadingPharmOrders$!: Observable<boolean>;
  @Select(PharmOrdersState.activePharmOrders) activePharmOrders$!: Observable<PharmOrder[]>;
  @Select(PharmOrdersState.error) errorPharm$!: Observable<CcsSentryError | null>;
  @Select(PatientState.patient) patient$!: Observable<Patient | null>;
  @Select(NotificationsState.notificationsState) notificationsState$!: Observable<ApiStoreData<Notification[]>>;
  @Select(PharmWizardSubmissionState.submitPharmReorder) submitPharmReorder$!: Observable<ApiStoreData<null>>;

  @Select(PharmAddressState.isLoading) isLoadingPharmAddress$!: Observable<boolean>;
  @Select(PharmAddressState.error) pharmAddressError$!: Observable<CcsSentryError | null>;
  @Select(PharmAddressState.pharmAddress) pharmAddress$!: Observable<PharmAddress[]>;

  billMatrixUrl?: string;
  newLeafPharmacyEnabled: boolean = false;
  checked: boolean = false;
  enterpriseOrderId: string = '';
  noMargin: boolean = true;
  pharmOrders: PharmOrder[] = [];
  pharmOrder?: PharmOrder = undefined;
  pharmOrderItems: PharmItem[] = [];
  orderNumber: string = '';
  customerAddressId: string = '';
  customerId: string = '';
  pharmacyLocation: string = '';
  pharmAddresses: PharmAddress[] = [];
  patientId: number = 0;
  pharmShippingAddress: PharmAddress = <PharmAddress>{};
  isChecked: boolean = false;
  isSubmittingPharmOrder: boolean = false;

  @Input() isTouched: boolean = false;
  @Input() disabled: boolean = false;

  isDirty: boolean = false;
  displayOrderSubmissionError: boolean = false;
  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private router: Router,
    private gtag: Gtag,

    private envService: EnvService
  ) {
    this.newLeafPharmacyEnabled = this.envService.features['newLeafPharmacy']?.enabled;
  }

  submitPharmOrder() {
    var submitOrder = false;
    this.enterpriseOrderId = this.route.snapshot.paramMap.get('enterpriseOrderId')!;
    this.activePharmOrders$.subscribe((orders) => {
      this.pharmOrders = orders as PharmOrder[];
      this.pharmOrder = this.pharmOrders.find((item) => item.enterpriseOrderId === this.enterpriseOrderId);
      this.orderNumber = this.pharmOrder?.orderNumber!;
      this.pharmOrderItems = this.pharmOrder?.items!;
      this.customerAddressId = this.pharmOrder?.customerAddressId!;
      this.customerId = this.pharmOrder?.customerId!;
      this.pharmacyLocation = this.pharmOrder?.pharmacyLocation!;

      this.patient$.subscribe((patient) => {
        this.patientId = patient?.id!;
      });
      if (!submitOrder) {
        this.store
          .dispatch(
            new SubmitPharmReorder(
              this.pharmacyLocation,
              this.patientId,
              this.enterpriseOrderId,
              this.pharmOrderItems,
              this.customerId,
              'Portal'
            )
          )
          .pipe(withLatestFrom(this.submitPharmReorder$))
          .subscribe(([_, submitPharmReorder]) => {
            //.subscribe((submitPharmReorder) => {
            if (!submitPharmReorder.error) {
              this.router.navigate(['/']);
              this.isSubmittingPharmOrder = false;
              this.messageService.add({
                key: 'homeToast',
                severity: 'success',
                detail: 'Thank you for your order, it has been submitted successfully.',
                sticky: true,
              });
              this.gtag.event('order_submission_success', {
                event_category: 'engagement',
                non_interaction: true,
              });
            } else {
              this.isSubmittingPharmOrder = false;
              this.showOrderSubmissionError();

              this.gtag.event('order_submission_failure', {
                event_category: 'engagement',
                non_interaction: true,
                error: submitPharmReorder.error.uiMessage,
              });
            }
          });
        submitOrder = true;
      }
    });
  }

  onSubmit() {
    this.isSubmittingPharmOrder = true;
    this.submitPharmOrder();
  }

  onChecked(event: { checked: boolean }) {
    this.isChecked = event.checked;
  }

  showOrderSubmissionError() {
    this.displayOrderSubmissionError = true;
  }

  ngOnInit(): void {
    this.enterpriseOrderId = this.route.snapshot.paramMap.get('enterpriseOrderId')!;

    if (this.enterpriseOrderId !== null && this.enterpriseOrderId !== '') {
      this.store.dispatch(new SetSelectedEnterpriseOrderId(this.enterpriseOrderId));
    } else {
      if (this.selectedEnterpriseOrderId$ !== null && this.selectedEnterpriseOrderId$ !== '') {
        this.enterpriseOrderId = this.selectedEnterpriseOrderId$;
      }
    }

    this.activePharmOrders$.subscribe((orders) => {
      if (!orders || orders.length <= 0) {
        this.store.dispatch(new FetchPharmOrders());
      } else {
        this.pharmOrders = orders as PharmOrder[];
        this.pharmOrder = this.pharmOrders.find((item) => item.enterpriseOrderId === this.enterpriseOrderId);
        this.orderNumber = this.pharmOrder?.orderNumber!;
        this.pharmOrderItems = this.pharmOrder?.items!;
        this.customerAddressId = this.pharmOrder?.customerAddressId!;
        this.customerId = this.pharmOrder?.customerId!;
        this.pharmacyLocation = this.pharmOrder?.pharmacyLocation!;

        this.patient$.subscribe((patient) => {
          this.patientId = patient?.id!;
        });

        this.store.dispatch(new FetchPharmAddress(this.pharmacyLocation, this.patientId, this.customerAddressId));

        this.pharmAddress$.subscribe((addresses) => {
          this.pharmAddresses = addresses as PharmAddress[];

          if (this.pharmAddresses.length > 0) {
            this.pharmShippingAddress.address1 = this.pharmAddresses[0].address1;
            this.pharmShippingAddress.address2 = this.pharmAddresses[0].address2;
            //this.pharmShippingAddress.address2 = 'C/O hello world';
            this.pharmShippingAddress.city = this.pharmAddresses[0].city;
            this.pharmShippingAddress.state = this.pharmAddresses[0].state;
            if (this.pharmAddresses[0].zip.includes('-')) {
              this.pharmShippingAddress.zip = this.pharmAddresses[0].zip;
            } else {
              this.pharmShippingAddress.zip =
                this.pharmAddresses[0].zip.slice(0, 5) + '-' + this.pharmAddresses[0].zip.slice(5);
            }
          }
        });
      }
    });
  }
}
